import React, { useState } from "react";
import styles from "../styles/SignIn.module.css";

const SignInPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSignIn = () => {
    // Basic validation for demonstration
    if (!email || !password) {
      alert("Please fill in all fields.");
      return;
    }
    alert(`Signing in with email: ${email}`);
  };

  return (
    <div className={styles.signinPage}>
      <div className={styles.signinContainer}>
        {/* Header */}
        <div className={styles.header}>
          <h1>Sign In</h1>
        </div>

        {/* Email Input */}
        <div className={styles.inputGroup}>
          <span className={styles.inputIcon}>✉️</span>
          <input
            type="email"
            placeholder="Your Email Here"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={styles.inputField}
          />
        </div>

        {/* Password Input */}
        <div className={styles.inputGroup}>
          <span className={styles.inputIcon}>🔒</span>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Your Password Here"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={styles.inputField}
          />
          <button
            className={styles.togglePassword}
            onClick={() => setShowPassword(!showPassword)}
          >
            👁️
          </button>
        </div>

        {/* Forgot Password Link */}
        <p className={styles.forgotPassword}>
          Forgot password? <a href="#">Recover here</a>
        </p>

        {/* Sign In Button */}
        <button className={styles.signinButton} onClick={handleSignIn}>
          Sign In
        </button>

        {/* Sign Up Link */}
        <p className={styles.signupLink}>
          Don’t have an account? <a href="/signup">Sign up here</a>
        </p>

        {/* Security Message */}
        <p className={styles.securityMessage}>🔒 Your info is safely secured</p>
      </div>
    </div>
  );
};

export default SignInPage;
